export default "__VITE_ASSET__DdYFe253__"